import { graphql } from 'react-apollo'
import { ApplicationError, NotFoundError } from '../../helpers/errors'
import { localISODate } from '../../helpers/date-helpers'
import query from './query.graphql'

const mapPropsToOptions = ({ id, centre }) => ({
  variables: {
    id,
    startsAt: localISODate(centre.timeZone),
  },
  errorPolicy: 'ignore',
})

const mapDataToProps = ({
  ownProps: { centre, id, slug },
  data: { service, loading, error },
}) => {
  if (error) {
    return {
      error: new ApplicationError(error),
    }
  } else if (loading) {
    return { loading }
  } else if (!service) {
    return {
      error: new NotFoundError(),
    }
  } else if (service.category === 'Parking') {
    return { redirect: `/${centre.slug}/parking` }
  } else if (slug !== service.slug) {
    return { redirect: `/${centre.slug}/service/${id}/${service.slug}` }
  }

  return {
    entry: {
      category: 'Service',
      title: service.title,
      shortDescription: service.shortDescription,
      body: service.bodyCopy,
      centre: service.centre,
      analyticsMetadata: service.analyticsMetadata,
    },
  }
}

const withServiceDetail = graphql(query, {
  options: mapPropsToOptions,
  props: mapDataToProps,
})

export default withServiceDetail
